'use client';

import { usePathname } from 'next/navigation';

// Hidden on individual case-study pages (a focused technical read) — shown
// everywhere else (home, work listing, about, contact) as a discovery CTA.
const HIDDEN_ON = /^\/work\/[^/]+$/;

export default function ContraFab() {
  const pathname = usePathname();
  if (HIDDEN_ON.test(pathname)) return null;

  return (
    <a
      href="https://contra.com/nivyan_dev?utm_campaign=HireMeOnContra&utm_medium=a8f0ffb2-6a33-4be6-935d-0406f7ff9978"
      target="_blank"
      rel="nofollow noopener"
      aria-label="Hire me on Contra (opens in new tab)"
      className="contra-fab"
    >
      <span className="contra-fab-dot" aria-hidden="true" />
      Hire me on Contra
      <span className="contra-fab-arrow" aria-hidden="true">→</span>
    </a>
  );
}
